<template lang="pug">
  .container-listagem
    app-modal(
      v-if="bytes"
      titulo="Certidão Negativa",
      :responsive="true"
      @closeModal="bytes = null"
    )
      template(slot="body")
        app-pdf-slider(
          v-if="bytes"
          :documentosBytes="arrayBytes"
        )
    modal-assinatura(
      v-if="modal"
      titulo="Assinar Ofício de Certidão Negativa"
      texto="Para realizar a assinatura do ofício de certidão negativa é necessário informar a senha do seu certificado digital. Ao finalizar, o documento será assinado."
      @closeModal="closeModal()"
      @callbackSucesso="callbackModalAssinatura"
    )
    el-row
      el-col
        Pesquisa(
          placeHolder = "Informe o nome da Gleba ou nº do Processo",
          @search="handlePesquisa"
          @resetSearch="resetPesquisa"
          :cardStyle="{margin:'0px 0px 10px 0px', 'border-radius':'12px'}"
        )

    el-card.default-card(shadow="hover")
      app-divider-refresh-button(
        label="Listagem de Processos",
        @click="resetPesquisa",
        :hasButton="true"
        content="Atualizar processos"
      )

      table-generica(
          :colunas="colunas",
          :botoesAcao="botoesAcao",
          :sortChanged='sortChanged',
          :dados='processosArrecadacao'
          )

    app-paginacao(
      :total="totalCadastros"
      :pagina="pagina",
      @changePage="changePage"
    )
</template>

<script>
import { mapActions } from 'vuex'
import ButtonAcoes from '@/components/ButtonAcoes'
import AppPaginacao from '@/components/AppPaginacao'
import AppDividerRefreshButton from '@/components/AppDividerRefreshButton'
import Pesquisa from '@/components/Pesquisa'
import Utils, { stringToArrayBuffer } from '@/utils/utils'
import statusProcesso from '@/constants/statusProcessoArrecadacao'
import statusOficio from '@/constants/statusOficioArrecadacao'
import TableGenerica from '@/components/TableGenerica'
import BaseFiltroArrecadacao from '@/screens/arrecadacao/mixins/BaseFiltroArrecadacao'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import FILTRO_EMPTY from '@/models/filtro'
import ModalAssinatura from '@/components/ModalAssinatura'
import AppModal from '@/components/AppModal'
import AppPdfSlider from '@/components/AppPDFSlider'

const CERTIDAO_NEGATIVA_ARRECADACAO = 'CERTIDAO_NEGATIVA_ARRECADACAO'

export default {
  components: {
    ButtonAcoes,
    AppPaginacao,
    AppDividerRefreshButton,
    Pesquisa,
    TableGenerica,
    ModalAssinatura,
    AppModal,
    AppPdfSlider
  },

  mixins: [BaseFiltroArrecadacao, AppNotificacao],

  data () {
    return {
      processo: null,
      modal: false,
      bytes: null,
      arrayBytes: [],
      colunas: [
        {
          prop: 'numeroProcesso',
          label: 'Processo',
          sortable: 'custom',
          formatter: Utils.formatEmptyRow
        },
        {
          prop: 'cadastroColetivo.pecaTecnica.gleba',
          label: 'Gleba',
          sortable: 'custom',
          formatter: Utils.formatEmptyRow
        },
        {
          prop: 'cadastroColetivo.pecaTecnica.municipios',
          label: 'Município',
          formatter: this.formatMunicipio,
          sortable: 'custom'
        },
        {
          prop: 'statusName',
          label: 'Situação',
          sortable: 'custom',
          formatter: this.formatStatus
        }
      ],
      filtro: FILTRO_EMPTY('ASSINATURAS'),
      Utils
    }
  },

  created () {
    this.init()
    this.setMainCardVisibility(false)
  },

  methods: {
    ...mapActions({
      setMainCardVisibility: 'userInterface/setMainCardVisibility',
      tramitarCertidaoNegativa: 'oficioArrecadacao/tramitarCertidaoNegativa',
      iniciarAnalise: 'processoArrecadacao/iniciarAnalise',
      findByProcessoId: 'oficioArrecadacao/findByProcessoId',
      assinarCertidaoNegativa: 'oficioArrecadacao/assinarCertidaoNegativa',
      getAllCertidoesPdfsByProcesso: 'oficioArrecadacao/getAllCertidoesPdfsByProcesso'
    }),

    goToEmissaoOficio (processo) {
      if (processo.status === statusProcesso.AGUARDANDO_EMISSAO_OFICIO_CN) {
        this.tramitarCertidaoNegativa(processo.id)
      }
      this.$router.push({
        name: 'cpat/oficio',
        query: {
          idProcesso: processo.id
        }
      })
    },

    openModal (processo) {
      this.processo = processo
      this.modal = true
    },

    closeModal () {
      this.modal = false
    },

    callbackModalAssinatura (senha) {
      this.findByProcessoId(this.processo.id)
        .then(res => {
          this.assinarCertidaoNegativa({
            idOficios: res.map(r => r.id),
            senha,
            tipoDocumentoAutenticavel: CERTIDAO_NEGATIVA_ARRECADACAO
          })
            .then(async res => {
              if (!this.$route.query.botaoEmitirOficio) {
                await this.tramitarCertidaoNegativa(this.processo.id)
              }
              this.closeModal()
              this.showNotificacao(
                this.$messages.TIPO_SUCCESS,
                this.$messages.TITULO_SUCCESS,
                this.$messages.CERTIDAO_NEGATIVA_ASSINADA_COM_SUCESSO
              )
              this.init()
            })
            .catch(err => {
              this.showNotificacao(
                this.$messages.TIPO_ERROR,
                this.$messages.TITULO_ERROR,
                err.message
              )
            })
        })
        .catch(() => {
          this.showNotificacao(
            this.$messages.TIPO_ERROR,
            this.$messages.TITULO_ERROR,
            this.$messages.CERTIDAO_NEGATIVA_NAO_ENCONTRADA
          )
        })
    },

    goToListagem (processo) {
      this.$router.push({
        name: 'cpat/assinatuas',
        query: {
          idProcesso: processo.id
        }
      })
    },

    getQuery (processo) {
      const query = {}

      if (processo.matricula) {
        query.idOficio = processo.matricula.id
      } else {
        query.idProcesso = processo.id
      }
      return query
    },

    goToMinuta (processo) {
      const query = this.getQuery(processo)
      this.$router.push({
        name: 'cpat/minuta',
        query
      })
    },

    async analisarProcesso (processo) {
      if (processo.status === statusProcesso.AGUARDANDO_ANALISE) {
        await this.iniciarAnalise({ processoId: processo.id })
      }
      this.$router.push({
        name: 'cpat/validacaoCadastro',
        query: {
          idProcesso: processo.id
        }
      })
    },

    enviarMatricula (processo) {
      this.$router.push({
        name: 'cpat/matricula',
        query: {
          idProcesso: processo.id
        }
      })
    },

    formatStatus (row, column, prop) {
      if (
        row.documentosAssinados.some(
          documento =>
            documento.status?.codigo === statusOficio.AGUARDANDO_RESPOSTA_SICARF
        )
      ) {
        return 'Cartório aguardando retorno'
      }
      return prop
    },

    async getPdfCertidaoNegativa (processo) {
      const documentos = await this.getAllCertidoesPdfsByProcesso(processo.id)
      this.arrayBytes = documentos.map(oficio => ({
        id: oficio.id,
        bytes: stringToArrayBuffer(oficio.bytes)
      }))
      this.bytes = this.arrayBytes[0].bytes
    },

    botoesAcao (processo) {
      const acoes = []

      const codigo = processo.status

      if (codigo === statusProcesso.AGUARDANDO_ASSINATURA_CN) {
        acoes.push({
          click: this.openModal.bind(this, processo),
          icon: 'edit',
          title: 'Assinar Certidão Negativa',
          active: true
        },
        {
          click: this.getPdfCertidaoNegativa.bind(this, processo),
          icon: 'visibility',
          title: 'Visualizar Certidão Negativa',
          active: true
        })
      }

      return acoes
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/screens/arrecadacao/cpat/Assinaturas.vue